import { ItemList } from 'orm'

class CompanyList extends ItemList {
    getEntityKey() {
        return "contact/company"
    }
}

export const contactCompanyList = new CompanyList("contact_company__default")
